//import React from 'react';

import React, {useEffect} from 'react';  
//import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import paths from '../../../routes/paths';
import { fetchWishlistProducts } from '../../../redux/slices/AuthSlice';
import { useDispatch,useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
//import { addToWishList, removeFromWishList } from '../../../redux/slices/AuthSlice';
// ProductViewModal from '../../Products/ProductViewModal';
//import Product from './Product';
import KurtisProduct from '../../Womens/Product';
import SareesProduct from '../../Products/Product';
import { Navigate } from "react-router-dom"
//import { getAuthToken } from '../../../utils/auth';

const  Wishlist = () => {
    const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
    const { wl_products,loggedInUser} = useSelector((state:any) => state.auth)
    //const [selectedProduct,setSelectedProduct] = useState('' as any)
   // const [modalShow, setModalShow] = useState(false);
    //const token = getAuthToken();

    // const handleModalClose = () => {
    //     setModalShow(false)
    // }

    // const handleModal= (product) => {
    //     setModalShow(true)
    //     setSelectedProduct(product);
    // }

    // const manageWishList = (product_id,type) => {
    //     // if (loggedInUser === null){
    //     //   setLoginModalShow(true)
    //     // }
    //     // else{ 
    //       if(type === "Add"){
    //         dispatch(addToWishList(product_id))
    //       }
    //       if(type === "Remove"){
    //         dispatch(removeFromWishList(product_id))
    //       }
    //     //}
    
    // }
 

    useEffect(() =>{
        dispatch(fetchWishlistProducts());
    },[dispatch])

    // const manageWishList = (product_id) => {
    //     dispatch(removeFromWishList(product_id)) 
    // } 

    if ( loggedInUser === null){
        return <Navigate replace={true} to={paths.home} />
    }

   // console.log("pro", wl_products[0])
  return (
    <div className="page-content bg-light">
        {/* <div className="dz-bnr-inr bg-secondary overlay-black-light" style="background-image:url(images/background/bg1.jpg);"> */}
        <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG">
            <div className="container">
                <div className="dz-bnr-inr-entry">
                    <h1>Wishlist</h1>
                    <nav aria-label="breadcrumb" className="breadcrumb-row">
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" className=" text-900">  Home </Link></li>
                            <li className="breadcrumb-item">Wishlist</li>
                        </ul>
                    </nav>
                </div>
            </div>	
        </div> 
        <div className="p-t40">
            <div className="container">
                <div className="row justify-content-center">
                            {wl_products && wl_products.length === 0 && "Your wishlist is currently empty. Add items to your wishlist to keep track."}
                            {wl_products && wl_products.map((product,index) => 
                                <>
                                    {product.subcategory.name === "Sarees" && <SareesProduct product={product} index={index} key={index} />} 
                                    {product.subcategory.name !== "Sarees" && <KurtisProduct product={product} index={index} key={index} /> }
                                </>
                            
                           )} 
                </div>
            </div>
        </div>

    </div>
  );
}

export default Wishlist;

 
